module.exports = __webpack_public_path__ + "img/loginBg.a08f286e.png";